var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.577,
    height: 20,
    viewBox: "0 0 23.577 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0a0a0a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-170 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4487.829 -847)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4663.829 869.024)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M144.4,234.815h-4.168a3.407,3.407,0,0,0-3.4,3.4v6.891a.681.681,0,0,0,.681.681h9.614a.681.681,0,0,0,.681-.681v-6.891A3.407,3.407,0,0,0,144.4,234.815Z",
    transform: "translate(-136.829 -234.815)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4665.224 860)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M171.207,38.84a4.092,4.092,0,1,0,4.093,4.093A4.1,4.1,0,0,0,171.207,38.84Z",
    transform: "translate(-167.114 -38.84)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170 -25.84)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.35 49.638)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M400.317,273.32h-1.823a4.743,4.743,0,0,1,.287,1.63v6.891a2.032,2.032,0,0,1-.117.681h3.014a2.044,2.044,0,0,0,2.042-2.042v-3.757A3.407,3.407,0,0,0,400.317,273.32Z",
    transform: "translate(-398.494 -273.32)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 49.638)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.939,274.951a4.743,4.743,0,0,1,.287-1.63H3.4a3.407,3.407,0,0,0-3.4,3.4v3.757a2.044,2.044,0,0,0,2.042,2.042H5.057a2.033,2.033,0,0,1-.117-.681Z",
    transform: "translate(0 -273.321)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.54 42.655)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.5,121.689a3.06,3.06,0,1,0,3.061,3.061A3.065,3.065,0,0,0,36.5,121.689Z",
    transform: "translate(-33.443 -121.689)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.915 42.655)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M348.668,121.689a3.061,3.061,0,1,0,3.061,3.061A3.065,3.065,0,0,0,348.668,121.689Z",
    transform: "translate(-345.607 -121.689)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgents);
export default __webpack_public_path__ + "static/media/agents.e7f3b8b2c21a301afb0369bd1651a3d0.svg";
export { ForwardRef as ReactComponent };